import React from 'react'
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter'
import { oneDark } from 'react-syntax-highlighter/dist/esm/styles/prism'

interface CodeDemoProps {
  code: string
  language: string
  showLineNumbers?: boolean
}

export const CodeDemo: React.FC<CodeDemoProps> = ({ 
  code, 
  language, 
  showLineNumbers = true 
}) => {
  return (
    <SyntaxHighlighter
      language={language}
      style={oneDark}
      showLineNumbers={showLineNumbers}
      customStyle={{
        margin: 0,
        padding: '1.5rem',
        fontSize: '0.875rem',
        lineHeight: '1.5',
        background: 'transparent'
      }}
      wrapLongLines={true}
    >
      {code}
    </SyntaxHighlighter>
  )
}